export var defaultProps = {
    className: '',
    wrapCls: '',
    defaultActive: -1,
    offsetTop: 0,
    activeCls: '',
    duration: 300,
    items: [],
    onChange: function (elevator) { },
    onBeforeChange: function (elevator) { return true; },
    triggerOffset: 100,
    onToggle: function (isShow) { },
    scrollContainer: window,
};
